/* eslint-disable */
import axios from "axios";
import store from "@/store";
import customModal from "../customModal/customModal.vue";
import QTLDetailsModal from "./QTLDetailsModal.vue";
import VPagination from "@hennge/vue3-pagination";
import manageQtlModal from "./manageQtlModal.vue";

export default {
    name: "QtlInfoModal",
    components: {
        customModal,
        VPagination,
        QTLDetailsModal,
        manageQtlModal
    },
    props: {
        data: Object,
    },
    emits: ["closeModal"],

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            token: "",
            studyId: "",
            loading: false,
            qtlList: [],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            totalPages: 1,
            selectedQTLItem: null,
            showQTLDetailsModal: false,
            openCreateQtlModal: false,
            qtlEditData: null,
        };
    },

    mounted() {
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;
        console.log("QtlInfoModal data", this.data);
        if (this.data) {
            this.fetchQtlList();
        }
    },

    watch: {
        data: {
            deep: true,
            handler(newVal) {
                if (newVal) {
                    this.currentPage = 1;
                    this.fetchQtlList();
                }
            },
        },
    },

    methods: {
        async fetchQtlList(page = this.currentPage) {
            this.loading = true;
            this.qtlList = [];

            try {
                const response = await axios.get(
                    `${this.baseurl}/forms/qtl/listall`,
                    {
                        params: {
                            StudyId: this.studyId,
                            CtqId: this.data.ctqid,
                            pageindex: page,
                            pagesize: this.pageSize,
                        },
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const result = response.data;

                if (result.entities && Array.isArray(result.entities)) {
                    this.qtlList = result.entities.map(i => ({ ...i, expanded: false }));
                    this.totalCount = result.totalCount || 0;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                } else if (Array.isArray(result)) {
                    this.qtlList = result.map(i => ({ ...i, expanded: false }));
                    this.totalCount = result.length;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                } else if (result) {
                    this.qtlList = [{ ...result, expanded: false }];
                    this.totalCount = 1;
                    this.totalPages = 1;
                }

                this.currentPage = page;
            } catch (error) {
                console.error("Error fetching QTL list:", error);
                this.qtlList = [];
                this.totalCount = 0;
                this.totalPages = 0;
            } finally {
                this.loading = false;
            }
        },
        loadPage(page) {
            this.fetchQtlList(page);
        },

        closeModal() {
            this.$emit("closeModal");
        },

        viewQTLDetails(item) {
            this.selectedQTLItem = item;
            this.showQTLDetailsModal = true;
        },

        closeQTLDetailsModal() {
            this.showQTLDetailsModal = false;
            this.selectedQTLItem = null;
        },

        openManageQTLModal(item) {
            if (item) {
                this.qtlEditData = { ...item };
            } else {
                this.qtlEditData = {
                    ctqId: this.data?.ctqid || "",
                    ctqFactor: this.data?.ctqFactor || "",
                    ctqCategory: this.data?.category || "",
                };
            }
            this.openCreateQtlModal = true;
        },

        closeQtlModal() {
            this.openCreateQtlModal = false;
            this.qtlEditData = null;
        },

        reloaddatagrid() {
            this.fetchQtlList();
        },

        truncate(text) {
            if (!text) return "";
            return text.length > 120 ? text.substring(0, 120) + "..." : text;
        },

        toggleExpand(item) {
            item.expanded = !item.expanded;
        },
    },
};
